import { getAppRequestHeaders } from '@/utils/appRequestHeaders'

/** Preserve fetch options and existing headers, adding version metadata only for EMMA. */
export default function appFetch(input, init) {
	const appHeaders = getAppRequestHeaders(input)
	if (!Object.keys(appHeaders).length) return fetch(input, init)

	const request = input instanceof Request ? input : null
	const headers = new Headers(init?.headers ?? request?.headers)
	Object.entries(appHeaders).forEach(([name, value]) => headers.set(name, value))

	const options = { ...init, headers }
	// Custom headers are silently dropped in no-cors mode. EMMA cross-origin
	// endpoints must allow these headers in their CORS configuration.
	if ((init?.mode ?? request?.mode) === 'no-cors') options.mode = 'cors'

	return fetch(input, options)
}
